import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'
import '../../src/refosumu/linkChange'

import './site_common'

import 'Components/refosumu/companies_index/search_panel/component'
import 'Components/refosumu/companies_index/search_result_header/component'

import 'Components/refosumu/company_card/component'
import 'Components/refosumu/example_card/component'
import 'Components/refosumu/review_card/component'
import 'Components/refosumu/generals/page_header/component'
import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/area_links/component'

import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/carousel_light/component'
import 'Components/refosumu/v2/floating/component'

import 'Components/refosumu/companies_index/page_title/component'
import 'Components/refosumu/companies_index/search_by_cities/component'
import 'Components/refosumu/companies_index/company_card/component'
import 'Components/refosumu/companies_index/company_card_list/component'
import 'Components/refosumu/companies_index/lazy_load_company_card_list/component'
import 'Components/refosumu/companies_index/subsidies_section/component'
import 'Components/refosumu/companies_index/reform_examples_section/component'
import 'Components/refosumu/companies_index/reform_example_card/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})
